module.exports = __webpack_public_path__ + "img/join-us-11.6bbc4311.png";